import "simplebar-react/dist/simplebar.min.css";

import { createRoot } from 'react-dom/client';
import App from "./App";
import "./i18nextConf";

const domNode = document.getElementById("root");
const root = createRoot(domNode as HTMLElement);

root.render(<App />);